module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp123_3016.d030fc45.png";